export function createAction(name) {
    return {
        Request: `${name}Request`,
        Success: `${name}Success`,
        Failure: `${name}Failure`,
    }
}